import { findParentNodeClosestToPos } from '@tiptap/core';

import type { Node_Type } from './../../../ricos-types';

import type { QueryItem } from '../../types';

const NAME = 'isChildOfNode';
const isChildOfNode: QueryItem =
  ({ editorQuery }) =>
  (nodeTypeName: Node_Type) => {
    const selection = editorQuery.editor.view.state.selection;
    const { $from } = selection;
    const parentNode = findParentNodeClosestToPos($from, node => node.type.name === nodeTypeName);

    return !!parentNode;
  };

export default { NAME, query: isChildOfNode };
